import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Form, GoogleAutocomplete, useGoogleApiLoader } from 'dash-ui';

const LocationSection = ({ address, setAddress }: any) => {
  const { t } = useTranslation('forms');
  const [defaultViewValue, setDefaultViewValue] = useState('');
  const isGoogleApiReady = useGoogleApiLoader();
  const ref = useRef<HTMLDivElement | null>(null);
  // FIXME: re-check
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const geocoder = isGoogleApiReady ? new google.maps.Geocoder() : null;

  const onPlaceSelected = (place: google.maps.places.PlaceResult) => {
    setAddress({
      placeId: place.place_id,
      lat: place.geometry?.location?.lat(),
      lng: place.geometry?.location?.lng(),
      ...place,
    });
  };

  useEffect(() => {
    if (address && geocoder) {
      geocoder.geocode({ placeId: address.placeId }, (result) => {
        if (result?.length) {
          setDefaultViewValue(result[0].formatted_address);
        }
      });
    }
  }, [geocoder, address]);

  return (
    <Box mb={4} ref={ref}>
      <Form.Group w="100%" mb={4}>
        <Form.Label>{t('labels.address')}</Form.Label>
        {isGoogleApiReady && (
          <GoogleAutocomplete
            defaultValue={defaultViewValue}
            placeholder={t('forms:placeholders.address') || ''}
            menuPortalTarget={ref.current}
            onPlaceSelected={onPlaceSelected}
          />
        )}
      </Form.Group>
    </Box>
  );
};

export default LocationSection;
